import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/browser";
import Routes from "./routes";
import * as serviceWorker from "./serviceWorker";
import "./polyfills";
import "./index.scss";

if (import.meta.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: import.meta.env.VITE_APP_SENTRY_DSN
  });
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Routes />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
